export type PackType = 'starter' | '3h_pack' | null

export const PACK_TYPE_OPTIONS = [
  { text: 'None', value: null },
  { text: 'Starter Pack', value: 'starter' },
  { text: '3h Pack', value: '3h_pack' },
]

export const PACK_ALLOWED_RANKS = {
  starter: ['noob', 'starter', 'rookie', 'casual'],
  '3h_pack': ['noob', 'starter'],
}
